export const ContactRight = () => {

    return (
        <>
            <h2 className='right-topic'>Get in Touch</h2>
            <div className='line'></div>
            <p> Let’s bring your ideas to life! Whether you're looking to collaborate on an exciting project, need assistance with web development, or simply want to say hello, feel free to reach out. I'm always open to new opportunities and connections.

                Drop me a message, and I'll get back to you as soon as possible. Let's build something amazing together!</p>
            <div className='right-details'>
                <div className='right-detail'>
                    <div className='pi pi-map-marker pi-design'></div>
                    <div className='loc-text'>Damascus , Syria</div>
                </div>
                <div className='right-detail'>
                    <div className='pi pi-mobile pi-design'></div>
                    <div className='loc-text'>+963 991 951 452</div>
                </div>
                <div className='right-detail'>
                    <div className='pi pi-envelope pi-design'></div>
                    <div className='loc-text'>yamanajlouni1@hotmail.com</div>
                </div>
            </div>
            <div className='right-social-media'>
                <a className='pi pi-facebook social-media-logo' href="https://www.facebook.com/yamanajlouni" target="_blank" rel="noreferrer" aria-label="Facebook" />
                <a className='pi pi-instagram social-media-logo' href="https://www.instagram.com/yamanajlouni/" target="_blank" rel="noreferrer" aria-label="Instagram" />
                <a className='pi pi-linkedin social-media-logo' href="www.linkedin.com/in/yaman-ajlouni" target="_blank" rel="noreferrer" aria-label="Linkedin" />
            </div>
        </>
    )
}
